<template>
	<div>
		<div class="print-solicitacao" v-if="exibir">
			<div class="row print">
				<flCabecalho widthimg="130" top="16" />
			</div>

			<div class="no-print" v-if="exibeHistoricoVisualizar">
				<p v-show="loadHistorico">
					<flCarregando />
				</p>
				<div v-show="!loadHistorico" class="row">
					<div class="col-xs-12 col-md-3 form-group" style="margin-top: 15px">
						<label>Comparar com versão:</label>
						<select
							v-model="historico_comparacao"
							class="form-control input-sm"
							@change="atualizaPassageirosHistorico"
						>
							<option value="">{{_traducao('global', 'nenhum')}}</option>
							<option v-for="item in historico" :value="item" :key="item.id">
								{{ item.nome.toUpperCase() }} -
								{{ item.data_cadastro | dataTempo }}
							</option>
						</select>
					</div>
				</div>
			</div>

			<div
				class="row no-print"
				style="margin-bottom: 0px"
				v-if="historico_comparacao != ''"
			>
				<div class="col-md-12">
					<p class="text-info">
						<i class="fa fa-fw fa-info-circle"></i>Em vermelho são exibidos os
						dados referentes a versão preenchida por
						<strong>{{ historico_comparacao.nome.toUpperCase() }}</strong> em
						<strong>{{ historico_comparacao.data_cadastro | dataTempo }}</strong
						>.
					</p>
				</div>
			</div>

			<div class="table-responsive" style="margin-top: 8px">
				<table style="width: 100%">
					<tr>
						<td>
							<!-- diário de bordo -->
							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="9"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}
											Nº {{ form.numero_diario_anac }}
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('cadAeronave', 'matricula') }}:</th>
										<th>{{ _traducao('global', 'categoriaRegistro') }}:</th>
										<th>{{ _traducao('cadAeronave', 'fabricante1') }}:</th>
										<th>{{ _traducao('menuVoo', 'menuVmodelo') }}:</th>
										<th>{{ _traducao('menuManutencao', 'menuMnumSerie') }}:</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ aeronave.prefixo }}
										</td>
										<td>{{ aeronave.categoria }} - {{ aeronave.sigla }}</td>
										<td>
											{{ aeronave.fabricante }}
										</td>
										<td>
											{{ aeronave.modelo }}
										</td>
										<td>
											{{
												aeronave.serial_number == null ||
												aeronave.serial_number == ''
													? 'N/A'
													: aeronave.serial_number
											}}
										</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="12"
											style="background: #eee"
											class="text-center"
										>
										{{ _traducao('global', 'registroDeVooParte1').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th
											colspan="12"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('global', 'tripulacao').toUpperCase() }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td colspan="12">
											<strong> {{ _traducao('global', 'dataVoo') }} : </strong>
											<span v-if="fusoHorario != 'UTC'">{{
												form.acionamento.split(' ')[0]
											}}</span>
											<span v-else>{{
												form.acionamento_utc.split(' ')[0]
											}}</span
											>(UTC<span v-show="fusoHorario != 'UTC'">{{
												labelUtc()
											}}</span
											>)
										</td>
									</tr>
									<tr v-for="(item, index) in form.tripulacao" :key="index">
										<template v-if="item.nome || item.anac">
											<td
												:colspan="aeronave.habilita_ovn === '1' ? 4 : 3"
												style="width: 25%"
											>
												<strong>CANAC {{ index + 1 }}:</strong>

												<template v-if="isVisualizarDiarioOperadorOuPiloto">
													{{ `${item.anac || 'N/A'} - ${item.nome || 'N/A'}` }}
												</template>

												<template v-else>
													{{
														item.anac == '' || item.anac == null
															? 'N/A'
															: item.anac
													}}
													-
													<span v-for="it in item.usuarios" :key="it.id_usuario"
														><span
															v-if="
																it.id_usuario == item.id_usuario ||
																it.id == item.id_usuario
															"
															>{{ it.trigrama | na }} - {{ it.nome }}</span
														>
													</span>
												</template>
											</td>
											<td
												:colspan="aeronave.habilita_ovn === '1' ? 2 : 3"
												style="width: 25%"
											>
												<strong> {{ _traducao('global', 'funcao') }} :</strong>
												<span v-if="form.voo_instrucao == '0'">{{
													item.funcao.toUpperCase()
												}}</span>
												<span v-if="form.voo_instrucao == '1'">
													<span v-if="item.funcao == 'Piloto em Comando'">
														{{
															_traducao('global', 'instrutorVoo').toUpperCase()
														}}
													</span>
													<span v-else>
														{{ item.funcao.toUpperCase() }}
													</span>
												</span>
											</td>
											<td
												:colspan="aeronave.habilita_ovn === '1' ? 2 : 3"
												:style="{
													width:
														aeronave.habilita_ovn === '1'
															? 'calc(50%/3)'
															: '25%'
												}"
											>
												<strong>{{ _traducao('global', 'apresentacao') }}: </strong>
												<span v-if="fusoHorario != 'UTC'">
													{{
														form.tripulacao.length > 0 ? item.apresentacao : ''
													}}<br />
													(UTC{{ labelUtc() }})
												</span>
												<span v-else>
													{{
														form.tripulacao.length > 0
															? _SQLDateToDateTime(
																	item.apresentacao_utc,
																	'DD/MM/YYYY HH:MM'
															  )
															: ''
													}}
													(UTC{{ labelUtc() }})
												</span>
											</td>
											<td
												colspan="2"
												v-if="
													aeronave.habilita_ovn === '1' && aeronave.tipo == 'H'
												"
												:style="{width: 'calc(50%/3)'}"
											>
												<strong>OVN:</strong>
												{{ item.sn_ovn | na }}
											</td>
											<td
												:colspan="aeronave.habilita_ovn === '1' ? 2 : 3"
												:style="{
													width:
														aeronave.habilita_ovn === '1'
															? 'calc(50%/3)'
															: '25%'
												}"
											>
												<strong>{{ _traducao('global', 'baseContratual') }}:</strong>
												<span>
													{{
														item.base_contratual ? item.base_contratual : 'N/A'
													}}
												</span>
											</td>
										</template>
									</tr>
									<tr>
										<td colspan="6">
											<strong>De:</strong> {{ form.de_select.sigla }} -
											{{ form.nome_cidade_de }} / {{ form.nome_estado_de }}
											<label v-show="Boolean(form.lat_inicio)">
												- Latitude: {{ form.lat_inicio }}</label
											>
											<label v-show="Boolean(form.lng_inicio)">
												- Longitude: {{ form.lng_inicio }}
											</label>
										</td>
										<td colspan="6">
											<strong>Para:</strong> {{ form.para_select.sigla }} -
											{{ form.nome_cidade_para }} /
											{{ form.nome_estado_para }}
											<label v-show="Boolean(form.lat_fim)">
												- Latitude: {{ form.lat_fim }}
											</label>
											<label v-show="Boolean(form.lng_fim)">
												- Longitude: {{ form.lng_fim }}
											</label>
										</td>
									</tr>
									<tr>
										<td colspan="3">
											<strong>{{ label_acionamento }}:</strong><br />
											<span v-if="fusoHorario != 'UTC'">{{
												form.acionamento
											}}</span>
											<span v-else>{{ form.acionamento_utc }}</span> (UTC<span
												v-show="fusoHorario != 'UTC'"
												>{{ labelUtc() }}</span
											>)<br />
											<small v-show="fusoHorario != 'UTC'"
												>{{ form.acionamento_utc }} (UTC)
											</small>
										</td>
										<td colspan="2">
											<strong>{{ _traducao('global', 'decolagem') }}:</strong><br />
											<span v-if="fusoHorario != 'UTC'">{{
												form.decolagem
											}}</span>
											<span v-else>{{ form.decolagem_utc }}</span> (UTC<span
												v-show="fusoHorario != 'UTC'"
												>{{ labelUtc() }}</span
											>)<br />
											<small v-show="fusoHorario != 'UTC'"
												>{{ form.decolagem_utc }} (UTC)</small
											>
										</td>
										<td colspan="3">
											<strong> {{ _traducao('global', 'pouso') }}:</strong><br />
											<span v-if="fusoHorario != 'UTC'">{{ form.pouso }}</span>
											<span v-else>{{ form.pouso_utc }}</span> (UTC<span
												v-show="fusoHorario != 'UTC'"
												>{{ labelUtc() }}</span
											>)<br />
											<small v-show="fusoHorario != 'UTC'"
												>{{ form.pouso_utc }} (UTC)</small
											>
										</td>
										<td colspan="3">
											<strong>{{ _traducao('global', 'corte') }}:</strong><br />
											<span v-if="fusoHorario != 'UTC'">{{ form.corte }}</span>
											<span v-else>{{ form.corte_utc }}</span> (UTC<span
												v-show="fusoHorario != 'UTC'"
												>{{ labelUtc() }}</span
											>)<br />
											<small v-show="fusoHorario != 'UTC'"
												>{{ form.corte_utc }} (UTC)</small
											>
										</td>
									</tr>
									<tr v-if="!exibePeso">
										<td colspan="12">
											<strong
												>{{ _traducao('global', 'naturezaDoVoo') }}:</strong
											>
											{{ form.tipo_missao.descricao }}
										</td>
									</tr>
									<tr v-if="exibePeso">
										<td colspan="6">
											<strong
												>{{ _traducao('global', 'naturezaDoVoo') }}:</strong
											>
											{{ form.tipo_missao.descricao }}
										</td>
										<!--Customização flysafe-->
										<td colspan="6">
											<strong>Peso da {{ cargaBagagem }}:</strong>
											{{ form.peso_carga | decimal }} KG
										</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="9"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('global', 'tempoDeVoo').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th>{{ label_horas_acionamento_corte }}:</th>
										<th>{{ _traducao('global', 'totalDecolagemPouso') }}:</th>
										<th>{{ _traducao('global', 'diurno') }}:</th>
										<th>{{ _traducao('global', 'noturno') }}:</th>
										<th>IFR REAL:</th>
										<th>{{ _traducao('global', 'ifrSimulado') }}</th>
										<th v-if="validarVfr == true">VFR:</th>
										<th>{{ _traducao('global', 'navegacao') }}:</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ form.tempo_voo_piloto | horimetro }}
											<small>({{ tempoVooPiloto }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('tempo_voo_piloto').mudou"
											>
												{{ validaCampo('tempo_voo_piloto').valor }}
											</div>
										</td>
										<td>
											{{ form.tempo_voo_motor | horimetro }}
											<small>({{ tempoVooMotor }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('tempo_voo_motor').mudou"
											>
												{{ validaCampo('tempo_voo_motor').valor }}
											</div>
										</td>
										<td>
											{{ form.vfr_diurno | horimetro }}
											<small> ({{ form.hora_vfr_diurno }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('vfr_diurno').mudou"
											>
												{{ validaCampo('vfr_diurno').valor }}
											</div>
										</td>
										<td>
											{{ form.vfr_noturno | horimetro }}
											<small> ({{ form.hora_vfr_noturno }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('vfr_noturno').mudou"
											>
												{{ validaCampo('vfr_noturno').valor }}
											</div>
										</td>
										<td>
											{{ form.ifr | horimetro }}
											<small> ({{ form.hora_ifr }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('hora_ifr').mudou"
											>
												{{ validaCampo('hora_ifr').valor }}
											</div>
										</td>
										<td>
											{{ form.ifr_simulado | horimetro }}
											<small> ({{ form.hora_ifr_simulado }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('hora_ifr_simulado').mudou"
											>
												{{ validaCampo('hora_ifr_simulado').valor }}
											</div>
										</td>
										<td v-if="validarVfr == true">
											{{ form.vfr | horimetro }}
											<small> ({{ form.hora_vfr }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('hora_vfr').mudou"
											>
												{{ validaCampo('hora_vfr').valor }}
											</div>
										</td>
										<td>
											{{ form.navegacao | horimetro }}
											<small> ({{ form.hora_navegacao }})</small>
											<div
												class="ha-diferenca"
												v-show="validaCampo('navegacao').mudou"
											>
												{{ validaCampo('navegacao').valor }}
											</div>
										</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="2"
											style="background: #eee"
											class="text-center"
										>
											{{ labelHorasTotaisAcionamentoCorte }}
										</th>
										<th
											colspan="2"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('global', 'horasTotaisDecolagemPouso') }}
											<small v-if="form.alteradoPeloMecanico"
												><br />* Editado pelo mecânico.</small
											>
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'inicial') }}:</th>
										<th>{{ _traducao('global', 'final') }}:</th>
										<th>{{ _traducao('global', 'inicial') }}:</th>
										<th>{{ _traducao('global', 'final') }}:</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ form.horimetro_inicial | horimetro }}
										</td>
										<td>
											{{ form.horimetro_final | horimetro }}
										</td>
										<td>
											{{ form.horimetro_inicial_manutencao | horimetro }}
										</td>
										<td>
											{{ form.horimetro_final_manutencao | horimetro }}
											<span
												v-tooltip="'Editado pelo mecânico'"
												v-if="form.alteradoPeloMecanico"
												>*</span
											>
										</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('global', 'dadosDoVoo').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th style="width: 11.1111%">
											{{ _traducao('global', 'combustivel') }}:
										</th>
										<th style="width: 11.1111%">POB:</th>
										<th style="width: 11.1111%">PAX:</th>
										<th style="width: 11.1111%" v-show="habilitaPartida">
											{{ _traducao('global', 'partidas') }}:
										</th>
										<th style="width: 11.1111%">
											{{ _traducao('global', 'pousos') }}:
										</th>
										<th
											v-if="
												aeronave.tipo == 'H' && aeronave.habilita_gancho == '1'
											"
											style="width: 11.1111%"
										>
											{{ _traducao('global', 'gancho') }}:
										</th>
										<th
											v-if="
												aeronave.tipo == 'H' && aeronave.habilita_guincho == '1'
											"
											style="width: 11.1111%"
										>
											{{ _traducao('global', 'guincho') }}:
										</th>
										<th
											style="width: 11.1111%"
											v-show="
												aeronave.habilita_flir == '1' && aeronave.tipo == 'H'
											"
										>
											{{ _traducao('global', 'usoDeFlir') }}:
										</th>
										<th
											style="width: 11.1111%"
											v-show="
												aeronave.habilita_ovn == '1' && aeronave.tipo == 'H'
											"
										>
											{{ _traducao('global', 'usoDeOvn') }}:
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<span v-if="form.unidade_combustivel == '%'">
												{{
													Number(
														(Number(aeronave.tanque) *
															Number(form.combustivel)) /
															100
													).toFixed(0)
												}}
												{{ aeronave.unidade_tanque }}
												<small
													>({{ form.combustivel | horimetro }}
													{{ form.unidade_combustivel }})</small
												>
											</span>
											<span v-else>
												{{ form.combustivel | horimetro }}
												{{ form.unidade_combustivel }}
											</span>
										</td>
										<td>
											{{ form.pob }}
											<div
												class="ha-diferenca"
												v-show="validaCampo('pob').mudou"
											>
												{{ validaCampo('pob').valor }}
											</div>
										</td>
										<td v-if="tripulacaoTecnica !== '1'">
											{{ form.pax }}
											<div
												class="ha-diferenca"
												v-show="validaCampo('pax').mudou"
											>
												{{ validaCampo('pax').valor }}
											</div>
										</td>
										<td v-else>0</td>
										<td v-show="habilitaPartida">
											<span
												>{{ form.total_partidas + form.partidas }} ({{
													form.partidas
												}})</span
											>
										</td>
										<td>
											<span
												>{{ form.total_pousos + form.pousos }} ({{
													form.pousos
												}})</span
											>
										</td>
										<td
											v-if="
												aeronave.tipo == 'H' && aeronave.habilita_gancho == '1'
											"
										>
											{{ form.total_gancho + form.gancho }}
											( {{ form.gancho }} )
										</td>
										<td
											v-if="
												aeronave.tipo == 'H' && aeronave.habilita_guincho == '1'
											"
										>
											{{ form.total_guincho + form.guincho }}
											( {{ form.guincho }} )
										</td>
										<td
											v-show="
												aeronave.habilita_flir == '1' && aeronave.tipo == 'H'
											"
										>
											<!-- <td v-if="aeronave.tipo == 'H'" > -->
											<span v-if="form.flir == '0'">{{
												_traducao('global', 'nao').toUpperCase()
											}}</span>
											<span v-if="form.flir == '1'">{{
												_traducao('global', 'sim').toUpperCase()
											}}</span>
											<div
												class="ha-diferenca"
												v-show="validaCampo('flir').mudou"
											>
												{{ validaCampo('flir').valor }}
											</div>
										</td>
										<td
											v-show="
												aeronave.habilita_ovn == '1' && aeronave.tipo == 'H'
											"
										>
											<span v-if="!verificaOvn(form.tripulacao)">{{
												_traducao('global', 'nao').toUpperCase()
											}}</span>
											<span v-if="verificaOvn(form.tripulacao)">{{
												_traducao('global', 'sim').toUpperCase()
											}}</span>
										</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="
									tipo == 'C' &&
									passageiros.length > 0 &&
									this.exibir_passageiros
								"
								class="table table-bordered table-condensed table-siga"
								:key="updateKey"
							>
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											<span v-if="tripulacaoTecnica == '1'">{{
												_traducao('global', 'tripulacaoTecnica').toUpperCase()
											}}</span>
											<span v-else>{{
												_traducao('global', 'passageiros').toUpperCase()
											}}</span>
											<div class="dropdown" style="display: inline-block">
												<a
													style="padding-top: 5px; cursor: pointer"
													title="Imprimir Passageiro"
													class="dropdown dropdown-toggle"
													type="button"
													id="dropdownMenuButton"
													data-toggle="dropdown"
													aria-haspopup="true"
													aria-expanded="false"
												>
													<i
														class="icon-imprimir"
														style="font-size: 18px; color: black"
														aria-hidden="true"
													></i>
												</a>
												<div
													class="dropdown-menu pull-right"
													aria-labelledby="dropdownMenuButton"
													style="
														position: absolute;
														color: black;
														left: 16px;
														background: rgba(999, 999, 999, 1);
														border: none;
														width: 80px !important;
														box-shadow: none;
														margin-right: 14%;
														padding: 10px;
														border: 1px solid #ccc;
													"
												>
													<a
														href="#"
														@click.prevent="
															clickPrintPassageiro(
																form,
																'imprimir_passageiro',
																form.id
															)
														"
														style="display: block; color: black"
													>
														<i
															class="fa fa-print"
															style="font-size: 12px"
															aria-hidden="true"
														></i>
														{{ _traducao('global', 'simples') }}
													</a>
													<a
														href="#"
														@click.prevent="
															clickPrintPassageiro(
																form,
																'imprimir_passageiro_completo',
																form.id
															)
														"
														style="display: block; color: black"
													>
														<i
															class="fa fa-print"
															style="font-size: 12px"
															aria-hidden="true"
														></i>
														{{ _traducao('global', 'completo') }}
													</a>
													<a
														href="#"
														@click.prevent="
															clickPrintPassageiro(
																form,
																'imprimir_passageiro_anac',
																form.id
															)
														"
														style="display: block; color: black"
													>
														<i
															class="fa fa-print"
															style="font-size: 12px"
															aria-hidden="true"
														></i>
														{{ _traducao('global', 'anac') }}
													</a>
												</div>
											</div>
										</th>
									</tr>
									<tr v-if="passageiros.length > 0">
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>{{ centrodeCusto }}</th>
										<th>{{ _traducao('menuRGordemmissao', 'menuOMcargo') }}</th>
										<th>{{ _traducao('menuMatricula', 'cpf') }}</th>
										<th>{{ _traducao('global', 'telefone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in passageiros" :key="index">
										<td>{{ item.nome | na }}</td>
										<td>{{ item.orgao | na }}</td>
										<td>{{ item.cargo | na }}</td>
										<td>{{ item.cpf | na }}</td>
										<td>{{ item.telefone | na }}</td>
									</tr>
									<tr>
										<td
											colspan="10"
											v-if="passageiros.length == 0"
											class="text-center"
										>
											{{ _traducao('global', 'semPassageiros').toUpperCase() }}
										</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											v-if="aeronave.habilita_ciclo_np == '0'"
											colspan="4"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('cadAeronave', 'dadosMotor') }}
										</th>
										<th
											v-if="aeronave.habilita_ciclo_np == '1'"
											colspan="5"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('cadAeronave', 'dadosMotor') }}
										</th>
									</tr>
									<tr v-if="aeronave.numero_voo == '1'">
										<th :colspan="aeronave.habilita_ciclo_np == '0' ? 4 : 5">
											{{ _traducao('global', 'numeroVoo') }}:
											{{ form.numero_voo }}
										</th>
									</tr>
									<tr>
										<th>Serial Number:</th>
										<th>{{ _traducao('global', 'horasMotor') }}</th>
										<th v-if="aeronave.tipo == 'H'">
											{{ aeronave.nomenclatura_n1 }}:
										</th>
										<th v-if="aeronave.tipo == 'A'">
											{{ _traducao('global', 'ciclos') }}:
										</th>
										<th v-else>{{ aeronave.nomenclatura_n2 }} :</th>
										<th
											v-if="
												aeronave.tipo == 'H' &&
												aeronave.habilita_ciclo_np == '1'
											"
										>
											{{ aeronave.nomenclatura_np }}:
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<div v-for="mt in form.trecho_motor" :key="mt.id + 'sn'">
												<div>
													{{
														mt.serial_number +
														(mt.lado == 'D' && form.trecho_motor.length == 2
															? (_traducao('global', 'direito'))
															: mt.lado == 'E' && form.trecho_motor.length == 2
															?  (_traducao('global', 'esquerdo')) 
															: '')
													}}
												</div>
											</div>
											<div v-if="form.trecho_motor.length == 0">N/A</div>
										</td>
										<td>
											<div v-for="mt in form.trecho_motor">
												{{ mt.total_horimetro | horimetro }}
												<small>({{ form.tempo_voo_motor | horimetro2 }})</small>
											</div>
										</td>
										<td v-if="aeronave.tipo == 'H'">
											<div
												v-for="mt in form.trecho_motor"
												:key="mt.id + 'cicloNg'"
											>
												<div>
													{{ mt.total_ciclo_ng | horimetro2 }}
													<small>({{ mt.ciclo_ng | horimetro2 }})</small>
												</div>
											</div>
											<div v-if="form.trecho_motor.length == 0">N/A</div>
										</td>
										<td>
											<div
												v-for="mt in form.trecho_motor"
												:key="mt.id + 'cicloNf'"
											>
												<div v-if="aeronave.tipo == 'H'">
													{{ mt.total_ciclo_nf | horimetro2 }}
													<small>({{ mt.ciclo_nf | horimetro2 }})</small>
												</div>
												<div v-else>
													{{ mt.total_ciclo_nf | horimetroSemDecimais }}
													<small
														>({{ mt.ciclo_nf | horimetroSemDecimais }})</small
													>
												</div>
											</div>
											<div v-if="form.trecho_motor.length == 0">N/A</div>
										</td>
										<td
											v-if="
												aeronave.tipo == 'H' &&
												aeronave.habilita_ciclo_np == '1'
											"
										>
											<div
												v-for="mt in form.trecho_motor"
												:key="mt.id + 'cicloNp'"
											>
												<div>
													{{ mt.total_ciclo_np | horimetro2 }}
													<small>({{ mt.ciclo_np | horimetro2 }})</small>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td
											colspan="10"
											v-if="
												form.verificacao_vor != '0' &&
												form.verificacao_vor != null &&
												mostraVor
											"
										>
											Realizado check de VOR conforme RBAC 91.171 (c) no VOR:
											{{ form.vor }}, na Radial: {{ form.radial_vor }}° a
											{{ form.afastamento_vor }} NM, havendo erro de
											{{ form.erro_vor }} graus na marcação entre o sistema
											duplo de VOR da aeronave
										</td>
									</tr>
								</tbody>
							</table>

							<!-- situacao tecnica da aeronave -->
							<table
								v-if="tipo == 'C' || tipo == 'I'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="4"
											style="background: #eee"
											class="text-center"
										>
										{{ _traducao('global', 'situacaoTecnicaAeronave').toUpperCase() }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<strong> {{ _traducao('global', 'tipoUltimaIntervencaoManutencao') }} : </strong
											><br />
											{{ form.descricao_ultima_inspecao }}
										</td>
										<td>
											<strong> {{ _traducao('global', 'tipoProximaIntervencaoManutencao') }} </strong
											><br />
											{{ form.descricao_proxima_inspecao }}
										</td>
										<td>
											<strong> 
												{{ _traducao('global', 'tipoHorasCelulaIntervencaoManutencao') }}
											</strong
											><br />
											<span v-if="form.horimetro_proxima == 0"> N/A </span>
											<span v-else>
												{{ form.horimetro_proxima | horimetro }}
												// {{ calculaHorimetroProximaIntervencao() }}
											</span>
										</td>
										<td>
											<strong>{{ _traducao('global', 'responsavel') }}:</strong
											><br />
											{{ form.nome_usuario_retorno + ' ' }}
											<span v-if="form.codigo_anac_usuario_retorno">{{
												form.codigo_anac_usuario_retorno
											}}</span>
										</td>
									</tr>
									<tr v-if="aeronave.tipo == 'A'">
										<td :colspan="aeronave.apu_aeronave.length > 0 ? '2' : '4'">
											<strong> {{ _traducao('global', 'possui') }} APU:</strong>
											<span v-if="aeronave.apu_aeronave.length > 0">SIM</span>
											<span v-if="aeronave.apu_aeronave.length == 0">NÃO</span>
										</td>

										<td colspan="2" v-if="aeronave.apu_aeronave.length > 0">
											<strong>Horímetro APU:</strong>
											<span>{{ form.horimetro_apu | horimetro }}</span>
										</td>
									</tr>
								</tbody>
							</table>

							<!-- discrepancias -->
							<table
								v-if="tipo == 'C' || tipo == 'I'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #f0f0f0"
											class="text-center"
										>
											 {{ _traducao('global', 'discrepancia1') .toUpperCase() }}
										</th>
									</tr>
									<tr v-if="form.discrepancia.length > 0">
										<th colspan="5">Registros da Tripulação</th>
										<th colspan="5">Aprovação de Retorno ao serviço</th>
									</tr>
									<tr v-if="form.discrepancia.length > 0">
										<th>Data Reg.:</th>
										<th>Discrepância:</th>
										<th>CANAC Reg.:</th>
										<th>Data Correção:</th>
										<th>ATA SPEC 100:</th>
										<th>Correção:</th>
										<th>CANAC Resp.:</th>
										<th>CANAC PIC.:</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="form.discrepancia.length == 0">
										<td colspan="8" class="text-center">
											{{
												_traducao('global', 'naoHaDiscrepancia').toUpperCase()
											}}
										</td>
									</tr>
									<tr v-for="(item, idx) in form.discrepancia" :key="idx">
										<td>
											{{ item.data_discrepancia | dataTempo }}
										</td>
										<td>
											{{ item.descricao }} <br />
											<small v-if="item.tipo == 'DISCREPANCIA'"
												>({{
													_traducao('global', 'discrepancia2').toUpperCase()
												}})</small
											>
											<small v-if="item.tipo == 'OCORRENCIA'"
												>({{
													_traducao('menuVoo', 'menuVocorrencia').toUpperCase()
												}})</small
											>
										</td>
										<td>
											{{ item.anac | na }} -
											{{ item.nome_usuario_discrepancia }}
										</td>
										<td>
											<div v-if="item.data_conclusao">
												{{ item.data_conclusao | dataTempo }}
											</div>
											<div v-else>N/A</div>
										</td>
										<td>
											{{ item._ata_completa | na }}
										</td>
										<td>
											<div v-if="item.acao_discrepancia.length > 0">
												{{
													item.acao_discrepancia[
														item.acao_discrepancia.length - 1
													].descricao_acao
												}}
											</div>
											<div v-else>N/A</div>
										</td>
										<td>
											<div v-if="item.anac_usuario_conclusao">
												{{ item.anac_usuario_conclusao | na }} -
												{{ item.nome_usuario_conclusao }}
											</div>
											<div v-else>N/A</div>
										</td>
										<td>
											<div
												v-for="(t, index) in form.tripulacao"
												v-show="t.funcao.toUpperCase() == 'PILOTO EM COMANDO'"
												:key="index"
											>
												<template v-if="t.nome || t.anac || t.trigrama">
													<template v-if="isVisualizarDiarioOperadorOuPiloto">
														{{ `${t.anac || 'N/A'} - ${t.nome || 'N/A'}` }}
													</template>
													<template v-else>
														{{
															t.anac == '' || t.anac == null ? 'N/A' : t.anac
														}}
														-
														<span v-for="it in t.usuarios" :key="it.id_usuario">
															<span v-if="it.id_usuario == t.id_usuario">{{
																it.nome
															}}</span>
														</span>
													</template>
												</template>
											</div>
										</td>
									</tr>
								</tbody>
							</table>

							<!-- OCORRENCIAAS -->
							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="5"
											style="background: #f0f0f0"
											class="text-center"
										>
											{{ _traducao('global', 'ocorrencias') .toUpperCase() }}
										</th>
									</tr>
									<tr v-if="form.ocorrencias.length > 0">
										<th>Data:</th>
										<th>Local</th>
										<th>Código Classificação:</th>
										<th>Qualificação Civil:</th>
										<th>Descrição dos Fatos:</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="form.ocorrencias.length == 0">
										<td colspan="5" class="text-center">NÃO HÁ OCORRÊNCIAS</td>
									</tr>
									<tr v-for="(item, idx) in form.ocorrencias" :key="idx">
										<td>
											{{ item.data }}
										</td>
										<td>
											{{ item.local }}
										</td>
										<td>
											{{ item.codigo_classificacao }}
										</td>
										<td>
											{{ item.qualificacao_civil }}
										</td>
										<td>
											{{ item.descricao_fatos }}
										</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="despacho != '' && tipo == 'C' && !diarioComercial"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="4"
											style="background: #f0f0f0"
											class="text-center"
										>
											{{
												_traducao('global', 'despachoDeAeronaves').toUpperCase()
											}}
										</th>
									</tr>
									<tr>
										<th style="width: 15%">
											{{ _traducao('global', 'codigo') }}:
										</th>
										<th style="width: 15%">
											{{ _traducao('global', 'data') }}:
										</th>
										<th style="width: 50%">
											{{ _traducao('global', 'historico') }}:
										</th>
										<!-- <th style="width:20%" >Finalizada?</th> -->
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ despacho.numero }}
										</td>
										<td>
											{{ despacho.data_inicio | dataTempo }} (UTC<span>{{
												_fusoHorario
											}}</span
											>)
										</td>
										<td style="white-space: inherit">
											{{ despacho.historico }}
										</td>
										<!-- <td>
                        {{form.finalizar_despacho == 1 ? 'SIM' : 'NÃO'}}
                    </td> -->
									</tr>
								</tbody>
							</table>

							<!-- ordem de missao -->
							<table
								v-if="
									despacho != '' &&
									despacho.id_ordem_missao != null &&
									tipo == 'C' &&
									!diarioComercial
								"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="4"
											style="background: #f0f0f0"
											class="text-center"
										>
											{{ _traducao('global', 'ordemDeMissao').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th style="width: 15%">
											{{ _traducao('global', 'codigo') }}:
										</th>
										<th style="width: 15%">
											{{ _traducao('global', 'data') }}:
										</th>
										<th style="width: 50%">
											{{ _traducao('global', 'historico') }}:
										</th>
										<!-- <th style="width:20%" >Finalizada?</th> -->
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ despacho.ordem_codigo }}
										</td>
										<td>
											{{ despacho.ordem_data_inicio | dataTempo }}
										</td>
										<td style="white-space: inherit">
											{{ despacho.ordem_descricao }}
										</td>
										<!-- <td>
                        {{form.finalizar_despacho == 1 ? 'SIM' : 'NÃO'}}
                    </td> -->
									</tr>
								</tbody>
							</table>

							<!-- tripulacao -->
							<table
								v-if="tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							></table>

							<!-- Verifica Vor -->
							<!-- <table
								v-if="form.verificacao_vor[0].verifica_vor == 'S'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('global', 'verificacaoDoVor') }}
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'defasagemVorI') }}:</th>
										<th>{{ _traducao('global', 'defasagemVorII') }}:</th>
										<th>{{ _traducao('global', 'dataDeVerificacao') }}:</th>
										<th>{{ _traducao('global', 'estadoDeVerificacao') }}:</th>
										<th>{{ _traducao('global', 'cidadeDeVerificacao') }}:</th>
										<th>{{ _traducao('global', 'okParaUso') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ Number(form.verificacao_vor[0].defasagem1) | na }}
										</td>
										<td>
											{{ Number(form.verificacao_vor[0].defasagem2) | na }}
										</td>
										<td>{{ form.verificacao_vor[0].data | dataTempo }}</td>
										<td>{{ form.verificacao_vor[0].id_estado | na }}</td>
										<td>{{ form.verificacao_vor[0].id_cidade | na }}</td>
										<td>
											{{
												form.verificacao_vor[0].aprovado == 'S'
													? 'SIM'
													: 'NÃO' | na
											}}
										</td>
									</tr>
								</tbody>
							</table> -->

							<!-- vitimas -->
							<table
								v-if="tipo == 'C' && vitimas.length > 0"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											{{ _traducao('global', 'vitimas').toUpperCase() }}
										</th>
									</tr>
									<tr v-if="vitimas.length > 0">
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>{{ _traducao('menuMatricula', 'cpf') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in vitimas" :key="index">
										<td>{{ item.nome | na }}</td>
										<td>{{ item.cpf | na }}</td>
									</tr>
									<tr>
										<td
											colspan="10"
											v-if="vitimas.length == 0"
											class="text-center"
										>
											{{ _traducao('global', 'semVitimas').toUpperCase() }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- cargas -->
							<table
								v-if="tipo == 'C' && form.carga == 'S'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="3"
											style="background: #f0f0f0"
											class="text-center"
										>
											{{
												_traducao('global', 'cargaTransportada').toUpperCase()
											}}
										</th>
									</tr>
									<tr v-if="form.carga == 'S'">
										<th>{{ _traducao('global', 'descricao') }}:</th>
										<th>{{ _traducao('global', 'pesoAprox') }}:</th>
										<th>{{ _traducao('global', 'cargaLiquida') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="form.carga == 'N'">
										<td colspan="3" class="text-center">
											{{ _traducao('global', 'naoHaCarga').toUpperCase() }}
										</td>
									</tr>
									<tr v-if="form.carga == 'S'">
										<td>
											{{ form.descricao_carga }}
										</td>
										<td>
											{{ form.peso_carga }}
										</td>
										<td>
											{{
												form.carga_liquida == 'S'
													? _traducao('global', 'sim').toUpperCase()
													: _traducao('global', 'nao').toUpperCase()
											}}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- SOLICITAÇÃO -->
							<table
								v-if="
									despacho != '' &&
									despacho.id_solicitacao != null &&
									tipo == 'C'
								"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="4"
											style="background: #f0f0f0"
											class="text-center"
										>
											SOLICITAÇÃO DE USO DE AERONAVE
										</th>
									</tr>
									<tr>
										<th style="width: 15%">
											{{ _traducao('global', 'codigo') }}:
										</th>
										<th style="width: 50%">
											{{ _traducao('global', 'descricao') }}:
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ despacho.solicitacao_codigo }}
										</td>
										<td style="white-space: inherit">
											{{ despacho.solicitacao_descricao }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- dados da missao -->
							<table
								v-if="tipo == 'C' && !diarioComercial"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th
											colspan="16"
											style="background: #f0f0f0"
											class="text-center"
										>
											{{ _traducao('global', 'dadosDaMissao').toUpperCase() }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td colspan="2" style="width: 15%" v-if="naoDefinirTipo == 0">
											<strong>{{ _traducao('global', 'origem') }}:</strong>
										</td>
										<td colspan="6" v-if="naoDefinirTipo == 0">
											<span v-if="form.tipo_voo == 'E'">{{
												_traducao('global', 'emergencial').toUpperCase()
											}}</span>
											<span v-if="form.tipo_voo == 'C'">{{
												labelCritica.toUpperCase()
											}}</span>
											<span v-if="form.tipo_voo == 'P'">{{
												_traducao('global', 'planejada').toUpperCase()
											}}</span>
										</td>
										<td colspan="2" style="width: 15%">
											<strong>{{ _traducao('global', 'base') }}:</strong>
										</td>
										<td colspan="4">
											<span v-for="b in bases" :key="b.id"
												><span v-if="b.id == form.base">{{
													b.descricao
												}}</span></span
											>
										</td>
									</tr>
									<tr v-show="exibeRedsSamu != 'Exibir nenhum'">
										<td colspan="2" style="width: 15%">
											<strong>{{ this.numeroOcorrenciaSamu }}:</strong>
										</td>
										<td colspan="6">
											{{ form.numero_chamada | na }}
										</td>
										<template v-if="exibeRedsSamu == 'Exibir os 2 campos'">
											<td colspan="2" style="width: 15%">
												<strong>{{ this.numeroOcorrencia193 }}:</strong>
											</td>
											<td colspan="4">
												{{ form.numero_bo | na }}
											</td>
										</template>
									</tr>
									<tr v-if="homologadoAnac">
										<td colspan="2">
											<strong
												>{{ _traducao('global', 'naturezaDoVoo') }}:</strong
											>
										</td>
										<td colspan="14" v-if="form.tipo_natureza">
											{{ form.tipo_natureza.sigla }} -
											{{ form.tipo_natureza.descricao }}
										</td>
									</tr>
									<tr>
										<td colspan="2" style="width: 15%">
											<strong
												>{{
													labelTipoMissao !== ''
														? labelTipoMissao
														: _traducao('global', 'tipoMissao')
												}}:</strong
											>
										</td>
										<td v-if="form.tipo_missao" colspan="6">
											{{ form.tipo_missao.descricao }}
										</td>
										<td
											v-if="habilitaDescMissao"
											colspan="2"
											style="width: 17%"
										>
											<strong
												>{{
													labelDescMissao !== ''
														? labelDescMissao
														: _traducao('menuAGtipoMissao', 'menuAGdescMissao2')
												}}:</strong
											>
										</td>
										<td v-if="habilitaDescMissao" colspan="4">
											{{ form.descricao }}
										</td>
									</tr>
									<!-- SE FOR PMSP -->
									<tr v-if="_idCliente == 14">
										<td colspan="2">
											<strong>{{ _traducao('global', 'acoes') }}:</strong>
										</td>
										<!-- Auto Localização -->
										<td colspan="2">
											<strong
												>{{ _traducao('global', 'autoLocalizacao') }}:</strong
											><br />
											{{ form.auto_localizado }}
										</td>

										<!-- Armas Apreendidas -->
										<td colspan="2">
											<strong
												>{{ _traducao('global', 'armasApreendidas') }}:</strong
											><br />
											{{ form.arma_apreendida }}
										</td>

										<!-- Pessoas Detidas -->
										<td colspan="2">
											<strong
												>{{ _traducao('global', 'pessoasDetidas') }}:</strong
											><br />
											{{ form.pessoa_detida }}
										</td>

										<!-- Pessoas Salvas -->
										<td colspan="2">
											<strong
												>{{ _traducao('global', 'pessoasSalvas') }}:</strong
											><br />
											{{ form.pessoa_salva }}
										</td>

										<!-- Valor Recuperado -->
										<td colspan="2">
											<strong
												>{{ _traducao('global', 'valorRecuperado') }}:</strong
											><br />
											{{ form.valor_recuperado | moeda }}
										</td>
									</tr>
									<tr
										v-if="
											form.tipo_missao.descricao ==
												'TRANSPORTE DE ÓRGÃOS E TECIDOS' ||
											form.tipo_missao.descricao == 'SAÚDE / SOCORRO'
										"
									>
										<!-- CORACAO -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'coracao') }}:</strong
											><br />
											{{ form.coracao }}
										</td>

										<!-- RIM -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'rim') }}:</strong><br />
											{{ form.rim }}
										</td>

										<!-- FIGADO -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'figado') }}:</strong
											><br />
											{{ form.figado }}
										</td>

										<!-- CORNEA -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'cornea') }}:</strong
											><br />
											{{ form.cornea }}
										</td>

										<!-- ESCLERO -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'esclero') }}:</strong
											><br />
											{{ form.esclero }}
										</td>

										<!-- PANCREAS -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'pancreas') }}:</strong
											><br />
											{{ form.pancreas }}
										</td>

										<!-- BAÇO -->
										<td colspan="5">
											<strong>{{ _traducao('global', 'baco') }}:</strong><br />
											{{ form.baco }}
										</td>
									</tr>
									<tr
										v-if="
											form.tipo_missao.descricao == 'MEIO AMBIENTE' ||
											form.tipo_missao.descricao == 'COMBATE A INCÊNDIO' ||
											form.tipo_missao.descricao == 'BUSCA E SALVAMENTO'
										"
									>
										<td colspan="16">
											<table
												class="table table-bordered table-condensed table-siga"
												style="margin-top: -3px"
											>
												<tbody>
													<!-- UNIDADE DE CONSERVAÇÃO -->
													<td
														v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE'"
													>
														<strong
															>{{
																_traducao('global', 'unidadeDeConservacao')
															}}:</strong
														><br />
														<div
															v-for="(un, k) in form.unidade_conservacao"
															:key="k"
														>
															<div
																v-if="form.existe_unidade_conservacao == '1'"
															>
																{{ un.obj.sigla }}
															</div>
														</div>
														<div v-if="form.existe_unidade_conservacao == '0'">
															NÃO
														</div>
													</td>

													<!-- BASE ORIGEM -->
													<td
														v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE'"
													>
														<strong
															>{{
																_traducao('global', 'baseDeOrigem')
															}}:</strong
														><br />
														{{ form.base_origem | na }}
													</td>

													<!-- BAMBI
                                <td v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE' || form.tipo_missao.descricao == 'COMBATE A INCÊNDIO'">
                                    <strong>{{_traducao('global','bambiBucket')}}:</strong><br/>
                                    {{form.bambi}}
                                </td> -->

													<!-- BRIGADISTAS -->
													<td
														v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE'"
													>
														<strong
															>{{ _traducao('global', 'brigadistas') }}:</strong
														><br />
														{{ form.brigadista }}
													</td>
													<!-- BUSCA E SALVAMENTO -->
													<td
														v-if="
															form.tipo_missao.descricao == 'BUSCA E SALVAMENTO'
														"
													>
														<strong
															>{{ _traducao('global', 'socorridos') }}:</strong
														><br />
														{{ form.socorrido }}
													</td>
												</tbody>
											</table>
										</td>
									</tr>

									<tr v-if="_idCliente != 41 && exibeClassificacao">
										<td colspan="2" style="width: 15%">
											<strong
												>{{ _traducao('global', 'classificacao') }}:</strong
											>
										</td>
										<td colspan="14">
											{{
												typeof form.classificacao === 'object'
													? form.classificacao.descricao
													: form.classificacao
											}}
										</td>
									</tr>

									<tr v-if="_idCliente != 41 && exibeClassificacao">
										<td colspan="2" style="width: 15%">
											<strong
												>{{ _traducao('global', 'subclassificacao') }}:</strong
											>
										</td>
										<td colspan="14">
											{{
												typeof form.subclassificacao === 'object'
													? form.subclassificacao.descricao
													: form.subclassificacao
											}}
										</td>
									</tr>

									<tr
										v-show="
											exibeObjetivosMissao == '1' || exibeContextoOperativo
										"
									>
										<td
											colspan="2"
											style="width: 15%"
											v-show="exibeObjetivosMissao == '1'"
										>
											<strong
												>{{
													_traducao('global', 'objetivosAlcancados')
												}}?</strong
											>
										</td>
										<td colspan="6" v-show="exibeObjetivosMissao == '1'">
											<span v-if="form.objetivo_alcancado == 'S'">{{
												_traducao('global', 'sim')
											}}</span>
											<span v-if="form.objetivo_alcancado == 'P'">{{
												_traducao('global', 'parcial')
											}}</span>
											<span v-if="form.objetivo_alcancado == 'N'">{{
												_traducao('global', 'nao')
											}}</span>
											<span v-if="form.objetivo_alcancado == ''">N/A</span>
										</td>
										<td
											colspan="2"
											style="width: 17%"
											v-show="exibeContextoOperativo"
										>
											<strong
												>{{ _traducao('global', 'contextoOperativo') }}:</strong
											>
										</td>
										<td colspan="4" v-show="exibeContextoOperativo">
											<span v-if="form.houve_contexto == '1'">{{
												form.contexto_operativo.descricao.toUpperCase()
											}}</span>
											<span v-if="form.houve_contexto == '0'">N/A</span>
										</td>
									</tr>

									<tr>
										<td colspan="2">
											<strong
												>{{
													_idCliente != 41
														? centrodeCusto
														: _traducao('global', 'clienteSolicitante')
												}}:</strong
											>
										</td>
										<td colspan="14">
											<span
												v-for="(itOrgao, idxOrgao) in form.orgao"
												:key="idxOrgao"
											>
												{{ itOrgao.orgao.sigla
												}}<strong
													v-for="(unid, indexUnid) in form.orgao[idxOrgao]
														.unidade"
													:key="indexUnid"
												>
													({{
														form.orgao[idxOrgao].unidade[indexUnid].unidade
															.descricao
													}})</strong
												><span
													v-html="idxOrgao < form.orgao.length - 1 ? ',' : '.'"
												></span>
											</span>
											<span v-if="form.orgao.length == 0"> N/A </span>
										</td>
									</tr>

									<tr>
										<td colspan="2">
											<strong>{{ _traducao('global', 'obs') }}:</strong>
										</td>
										<td colspan="14" style="white-space: inherit">
											{{ form.observacao }}
										</td>
									</tr>
								</tbody>
							</table>

							<table
								class="table table-bordered table-condensed table-siga"
								v-else
							>
								<tr style="height: 25px">
									<td style="width: 6%">
										<strong>{{ _traducao('global', 'obs') }}:</strong>
									</td>
									<td
										colspan="4"
										style="white-space: inherit; text-align: left"
									>
										{{ form.observacao }}
									</td>
								</tr>
							</table>

							<!-- assinatura eletronica -->
							<table
								class="table table-bordered table-condensed table-siga"
								style="margin-top: 10px !important"
								v-if="
									(form.nome_usuario_assinou != '' ||
										form.nome_mecanico_assinou != '') &&
									tipo == 'C'
								"
							>
								<tbody>
									<tr>
										<td>
											<div class="row">
												<div class="col-xs-2">
													<img
														class="img-responsive img-ass"
														src="../../../../../assets/img/assinatura_eletronica.png"
													/>
												</div>

												<div class="col-xs-10">
													<p
														style="
															margin-top: 4px !important;
															margin-bottom: 4px !important;
														"
														v-if="form.nome_usuario_assinou != ''"
													>
														{{
															_traducao(
																'global',
																'assinaturaDigitalPilotoComando'
															)
														}}
														<strong>{{ form.nome_usuario_assinou }}</strong>
														{{ _traducao('global', 'em') }}
														<strong
															>{{ form.data_assinatura_piloto | dataTempo }}
															<span>(UTC{{ (aeronave.fuso_horario != '' && aeronave.fuso_horario != null) ? _fusoHorarioAeronave(aeronave.fuso_horario) : _fusoHorario }}</span
															>)</strong
														>.
													</p>
													<p
														v-if="
															showAssinaturaMecanico()
														"
													>
														{{
															_traducao('global', 'assinaturaDigitalMecanico')
														}}
														<strong>{{ form.nome_mecanico_assinou }}</strong>
														{{ _traducao('global', 'em') }}
														<strong
															>{{ form.data_assinatura_mecanico | dataTempo }}
															<span>(UTC{{ (aeronave.fuso_horario != '' && aeronave.fuso_horario != null) ? _fusoHorarioAeronave(aeronave.fuso_horario) : _fusoHorario }}</span
															>)</strong
														>.
													</p>
													<p v-if="form.nome_operador_assinou != ''">
														{{
															_traducao('global', 'assinaturaDigitalOperador')
														}}
														<strong>{{ form.nome_operador_assinou }}</strong>
														{{ _traducao('global', 'em') }}
														<strong
															>{{ form.data_assinatura_operador | dataTempo }}
															<span>(UTC{{ (aeronave.fuso_horario != '' && aeronave.fuso_horario != null) ? _fusoHorarioAeronave(aeronave.fuso_horario) : _fusoHorario }}</span
															>)</strong
														>.
													</p>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>

							<!-- posicoes -->
							<table
								class="table table-bordered table-condensed table-siga no-print"
								v-if="posicoes.length > 0 && voo"
							>
								<thead>
									<tr>
										<th
											colspan="16"
											style="background: #f0f0f0"
											class="text-center"
										>
											{{ _traducao('global', 'voo').toUpperCase() }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<div ref="map" style="width: 100%; height: 450px"></div>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</table>
			</div>

			<flGeradoPor />

			<pre style="display: none">
			{{ form }}
		</pre
			>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		name: String,
		cabecalho: Boolean,
		voo: {
			type: Boolean,
			default: true,
			required: false
		},
		exibeHistoricoVisualizar: {
			type: Boolean,
			default: false,
			required: false
		},
		isVisualizarDiarioOperadorOuPiloto: {
			type: Boolean,
			required: false,
			default: false
		},
		idMotorEsquerdo: {
			type: [Number, String]
		},
		idMotorDireito: {
			type: [Number, String]
		},
		fusoHorario: {
			type: String,
			default: 'local'
		}
	},

	computed: {
		tempoVooMotor() {
			var dec = moment(
				this.form.decolagem,
				$sessao.getDateFormat() + ' HH:mm'
			).locale(this._getLangDp)
			var pouso = moment(
				this.form.pouso,
				$sessao.getDateFormat() + ' HH:mm'
			).locale(this._getLangDp)

			var diff = pouso.diff(dec)
			var duration = moment.duration(diff)

			var $hours = duration.hours()
			var $days = duration.days()
			var $minutes = duration.minutes()

			var hora = ''
			var minuto = ''

			if (!_.isNil($hours)) {
				if (Number($hours) < 10) {
					hora = '0' + $hours
				} else {
					hora = $hours
				}
			} else {
				hora = '00'
			}

			if (!_.isNil($minutes)) {
				if (Number($minutes) < 10) {
					minuto = '0' + $minutes
				} else {
					minuto = $minutes
				}
			} else {
				minuto = '00'
			}

			var h = Number(hora) + $days * 24
			return (h < 10 ? '0' + h : h) + ':' + minuto + ':00'
		},

		tempoVooPiloto() {
			var dec = moment(
				this.form.acionamento,
				$sessao.getDateFormat() + ' HH:mm'
			).locale(this._getLangDp)
			var pouso = moment(
				this.form.corte,
				$sessao.getDateFormat() + ' HH:mm'
			).locale(this._getLangDp)

			var diff = pouso.diff(dec)
			var duration = moment.duration(diff)

			var $hours = duration.hours()
			var $days = duration.days()
			var $minutes = duration.minutes()

			var hora = ''
			var minuto = ''

			if (!_.isNil($hours)) {
				if (Number($hours) < 10) {
					hora = '0' + $hours
				} else {
					hora = $hours
				}
			} else {
				hora = '00'
			}

			if (!_.isNil($minutes)) {
				if (Number($minutes) < 10) {
					minuto = '0' + $minutes
				} else {
					minuto = $minutes
				}
			} else {
				minuto = '00'
			}

			var h = Number(hora) + $days * 24
			return (h < 10 ? '0' + h : h) + ':' + minuto + ':00'
		}
	},

	data() {
		return {
			labelHorasTotaisAcionamentoCorte: '',
			label_horas_acionamento_corte: '',
			habilitaPartida: false,
			labelCritica: '',
			updateKey: 0,
			pdf: false,
			exibir: false,
			comparando: false,
			loadHistorico: true,
			validarVfr: '',
			homologadoAnac: false,
			labelTipoMissao: '',
			habilitaDescMissao: true,
			labelDescMissao: '',
			exibeContextoOperativo: false,
			exibeClassificacao: false,
			exibeAssinaturaMecanico: true,
			numeroOcorrenciaSamu: '',
			numeroOcorrencia193: '',
			exibeObjetivosMissao: '',
			exibeRedsSamu: '',
			centrodeCusto: '',
			estados: [],
			cidades: [],
			mostraVor: false,
			exibePeso: true,
			diarioComercial: false,
			exibir_passageiros: true,
			flagFuso: '',

			ovns: {
				id: '',
				sn: '',
				horimetro_inicial: '',
				data_cadastro: '',
				observacoes: '',
				horimetro_atual: ''
			},

			form: {
				para_select: '',
				de_select: '',
				passageiro: [],
				tripulante: [],
				discrepancia: [],
				orgao: [],
				voo: null
			},
			tipo: 'C',

			aeronave: {
				prefixo: '',
				codinome: '',
				tipo: '',
				modelo: '',
				serial_number: null,
				tripulacao: [],
				passageiro: []
			},

			configMapa: {
				lat: 0,
				long: 0,
				zoom: 0
			},

			posicoes: [],
			bases: [],

			trilhas: [],
			markers: [],
			map: null,

			passageiros: [],
			vitimas: [],

			ordem: '',
			despacho: '',
			pilotos: '',
			historico: [],
			historico_comparacao: '',
			label_acionamento: 'Partida',
			cargaBagagem: 'Carga/bagagem',
			tripulacaoTecnica: false,
			pilotoPodeAssinarComoMecanico: false,
			naoDefinirTipo: 0,
		}
	},

	mounted() {
		this._providerBaseOperacional((lista) => (this.bases = lista))
		this.validar(23)
		this._getParametro(27).then(
			(valor) => (this.homologadoAnac = Number(valor) == 1)
		)
		this._getParametro(28).then((valor) => (this.labelTipoMissao = valor))
		this._getParametro(29).then(
			(valor) => (this.habilitaDescMissao = Number(valor) == 1)
		)
		this._getParametro(30).then((valor) => (this.labelDescMissao = valor))
		this._getParametro(81).then((valor) => (this.labelCritica = valor))
		this._getParametro(78).then((valor) => (this.exibeObjetivosMissao = valor))
		this._getParametro(52).then((valor) => (this.centrodeCusto = valor))
		this._getParametro(74).then((valor) => (this.label_acionamento = valor))

		this._getParametro(91).then(
			(valor) => (this.habilitaPartida = Number(valor) == 1)
		)
		this._getParametro(113).then(
			(valor) => (this.exibePeso = Number(valor) == 1)
		)
		this._getParametro(114).then(
			(valor) => (this.diarioComercial = Number(valor) == 1)
		)
		this._getParametro(116).then(
			(valor) => (this.label_horas_acionamento_corte = valor)
		)
		this._getParametro(115).then(
			(valor) => (this.exibir_passageiros = Number(valor) == 1)
		)
		this._getParametro(118).then(
			(valor) => (this.labelHorasTotaisAcionamentoCorte = valor)
		)
		this._getParametro(119).then((valor) => (this.cargaBagagem = valor))
		this._getParametro(145).then((valor) => (this.tripulacaoTecnica = valor))
		this._getParametro(177).then(
				(valor) => (this.pilotoPodeAssinarComoMecanico = Number(valor) == 1)
			)
		this._getParametro(187).then((valor) => (this.naoDefinirTipo = valor))
	},

	created() {
		this._exibeRedsSamu()
		this.numeroOcorrenciasSamu()
		this.numeroOcorrencias193()
		this._getParametro(49).then(
			(valor) => (this.mostraVor = Number(valor) === 1)
		)
		this._getParametro(89).then(
			(valor) => (this.exibeContextoOperativo = Number(valor) == 1)
		)
		this._getParametro(90).then(
			(valor) => (this.exibeClassificacao = Number(valor) == 1)
		)
		this._getParametro(94).then(
			(valor) => (this.exibeAssinaturaMecanico = Number(valor))
		)
		this.flagFuso = $cliente.get('horario_db')
	},

	methods: {
		showAssinaturaMecanico(){
			if(this.pilotoPodeAssinarComoMecanico){
				const sem_trecho_discrepancia = this.form.discrepancia.length <= 0
				if(sem_trecho_discrepancia){
					const assinaturaPilotoIgualMecanico = this.form.id_assinatura_piloto == this.form.id_assinatura_mecanico
					return !assinaturaPilotoIgualMecanico
				}else {
					const assinaturaPilotoDiferentelMecanico = this.form.id_assinatura_piloto != this.form.id_assinatura_mecanico
					return assinaturaPilotoDiferentelMecanico
				}
			} else {
				return this.form.nome_mecanico_assinou != '' && this.exibeAssinaturaMecanico
			}
		},

		atualizaPassageirosHistorico() {
			if (this.historico_comparacao) {
				let historico = this.historico_comparacao.objeto
				this.passageiros = historico.passageiro
				this.updateKey++
			}
		},

		labelUtc() {
			if (this.flagFuso == 'UTC') {
				return ''
			} else if (this.form.diferenca_fuso_horario) {

				if(this.aeronave.fuso_horario != '' && this.aeronave.fuso_horario != null){
					return this._fusoHorarioAeronave(this.aeronave.fuso_horario)
				} else {
					return this.form.diferenca_fuso_horario
				}

			} else {
				return this._fusoHorario
			}
		},

		validar(id) {
			this._getParametro(id).then((valor) => (this.validarVfr = valor))
		},

		validaCampo(tipo) {
			if (_.isNil(this.historico_comparacao.objeto)) {
				return false
			}

			if (tipo == 'acionamento') {
				if (
					this.form.acionamento !=
					this._SQLDateToDateTime(
						this.historico_comparacao.objeto.acionamento,
						$sessao.getDateFormat() + ' HH:MM'
					)
				) {
					return {
						mudou:
							this.form.acionamento !=
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.acionamento,
								$sessao.getDateFormat() + ' HH:MM'
							),
						valor:
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.acionamento,
								$sessao.getDateFormat() + ' HH:MM'
							) +
							'</br>' +
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.acionamento_utc,
								$sessao.getDateFormat() + ' HH:MM'
							)
					}
				}
			}
			if (tipo == 'decolagem') {
				if (
					this.form.decolagem !=
					this._SQLDateToDateTime(
						this.historico_comparacao.objeto.decolagem,
						$sessao.getDateFormat() + ' HH:MM'
					)
				) {
					return {
						mudou:
							this.form.decolagem !=
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.decolagem,
								$sessao.getDateFormat() + ' HH:MM'
							),
						valor:
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.decolagem,
								$sessao.getDateFormat() + ' HH:MM'
							) +
							'</br>' +
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.decolagem_utc,
								$sessao.getDateFormat() + ' HH:MM'
							)
					}
				}
			}
			if (tipo == 'de') {
				if (this.form.de_select.sigla != this.historico_comparacao.objeto.de) {
					return {
						mudou:
							this.form.de_select.sigla != this.historico_comparacao.objeto.de,
						valor: this.historico_comparacao.objeto.de
					}
				}
			}
			if (tipo == 'nome_estado_de') {
				if (
					this.form.nome_estado_de !=
					this.historico_comparacao.objeto.estado_inicio_missao
				) {
					return {
						mudou:
							this.form.nome_estado_de !=
							this.historico_comparacao.objeto.estado_inicio_missao,
						valor: this.historico_comparacao.objeto.estado_inicio_missao
					}
				}
			}
			if (tipo == 'nome_cidade_de') {
				if (
					this.form.nome_cidade_de !=
					this.historico_comparacao.objeto.cidade_inicio_missao
				) {
					return {
						mudou:
							this.form.nome_cidade_de !=
							this.historico_comparacao.objeto.cidade_inicio_missao,
						valor: this.historico_comparacao.objeto.cidade_inicio_missao
					}
				}
			}
			if (tipo == 'pouso') {
				if (
					this.form.pouso !=
					this._SQLDateToDateTime(
						this.historico_comparacao.objeto.pouso,
						$sessao.getDateFormat() + ' HH:MM'
					)
				) {
					return {
						mudou:
							this.form.pouso !=
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.pouso,
								$sessao.getDateFormat() + ' HH:MM'
							),
						valor:
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.pouso,
								$sessao.getDateFormat() + ' HH:MM'
							) +
							'</br>' +
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.pouso_utc,
								$sessao.getDateFormat() + ' HH:MM'
							)
					}
				}
			}
			if (tipo == 'corte') {
				if (
					this.form.corte !=
					this._SQLDateToDateTime(
						this.historico_comparacao.objeto.corte,
						$sessao.getDateFormat() + ' HH:MM'
					)
				) {
					return {
						mudou:
							this.form.corte !=
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.corte,
								$sessao.getDateFormat() + ' HH:MM'
							),
						valor:
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.corte,
								$sessao.getDateFormat() + ' HH:MM'
							) +
							'</br>' +
							this._SQLDateToDateTime(
								this.historico_comparacao.objeto.corte_utc,
								$sessao.getDateFormat() + ' HH:MM'
							)
					}
				}
			}
			if (tipo == 'para') {
				if (
					this.form.para_select.sigla != this.historico_comparacao.objeto.para
				) {
					return {
						mudou:
							this.form.para_select.sigla !=
							this.historico_comparacao.objeto.para,
						valor: this.historico_comparacao.objeto.para
					}
				}
			}
			if (tipo == 'nome_estado_para') {
				if (
					this.form.nome_estado_para !=
					this.historico_comparacao.objeto.estado_termino_missao
				) {
					return {
						mudou:
							this.form.nome_estado_para !=
							this.historico_comparacao.objeto.estado_termino_missao,
						valor: this.historico_comparacao.objeto.estado_termino_missao
					}
				}
			}
			if (tipo == 'nome_cidade_para') {
				if (
					this.form.nome_cidade_para !=
					this.historico_comparacao.objeto.cidade_termino_missao
				) {
					return {
						mudou:
							this.form.nome_cidade_para !=
							this.historico_comparacao.objeto.cidade_termino_missao,
						valor: this.historico_comparacao.objeto.cidade_termino_missao
					}
				}
			}
			if (tipo == 'tempo_voo_piloto') {
				if (
					this.form.tempo_voo_piloto !=
					this.historico_comparacao.objeto.tempo_voo_piloto
				) {
					let historico =
						this.historico_comparacao.objeto.tempo_voo_piloto +
						' (' +
						this.calculaTempoAnterior(
							this.historico_comparacao.objeto.tempo_voo_piloto
						) +
						')'
					return {
						mudou:
							this.form.tempo_voo_piloto !=
							this.historico_comparacao.objeto.tempo_voo_piloto,
						valor: historico
					}
				}
			}
			if (tipo == 'tempo_voo_motor') {
				if (
					this.form.tempo_voo_motor !=
					this.historico_comparacao.objeto.tempo_voo_motor
				) {
					return {
						mudou:
							this.form.tempo_voo_motor !=
							this.historico_comparacao.objeto.tempo_voo_motor,
						valor: this.historico_comparacao.objeto.tempo_voo_motor
					}
				}
			}
			if (tipo == 'vfr_diurno') {
				if (
					this.form.hora_vfr_diurno !=
					this.historico_comparacao.objeto.hora_vfr_diurno
				) {
					let decimal
					if (this.historico_comparacao.objeto.hora_vfr_diurno != '00:00:00') {
						decimal =
							' (' +
							this._timeToDecimal(
								'28/01/1991 00:00',
								'28/01/1991 ' + this.historico_comparacao.objeto.hora_vfr_diurno
							) +
							')'
					} else {
						decimal = ' (0.0)'
					}
					return {
						mudou:
							this.form.hora_vfr_diurno !=
							this.historico_comparacao.objeto.hora_vfr_diurno,
						valor: this.historico_comparacao.objeto.hora_vfr_diurno + decimal
					}
				}
			}
			if (tipo == 'vfr_noturno') {
				if (
					this.form.hora_vfr_noturno !=
					this.historico_comparacao.objeto.hora_vfr_noturno
				) {
					let decimal
					if (this.historico_comparacao.objeto.hora_vfr_noturno != '00:00:00') {
						decimal =
							' (' +
							this._timeToDecimal(
								'28/01/1991 00:00',
								'28/01/1991 ' +
									this.historico_comparacao.objeto.hora_vfr_noturno
							) +
							')'
					} else {
						decimal = ' (0.0)'
					}
					return {
						mudou:
							this.form.hora_vfr_noturno !=
							this.historico_comparacao.objeto.hora_vfr_noturno,
						valor: this.historico_comparacao.objeto.hora_vfr_noturno + decimal
					}
				}
			}
			if (tipo == 'hora_ifr') {
				if (this.form.hora_ifr != this.historico_comparacao.objeto.hora_ifr) {
					let decimal
					if (this.historico_comparacao.objeto.hora_ifr != '00:00:00') {
						decimal =
							' (' +
							this._timeToDecimal(
								'28/01/1991 00:00',
								'28/01/1991 ' + this.historico_comparacao.objeto.hora_ifr
							) +
							')'
					} else {
						decimal = ' (0.0)'
					}
					return {
						mudou:
							this.form.hora_ifr != this.historico_comparacao.objeto.hora_ifr,
						valor: this.historico_comparacao.objeto.hora_ifr + decimal
					}
				}
			}
			if (tipo == 'navegacao') {
				if (
					this.form.hora_navegacao !=
					this.historico_comparacao.objeto.hora_navegacao
				) {
					let decimal
					if (this.historico_comparacao.objeto.hora_navegacao != '00:00:00') {
						decimal =
							' (' +
							this._timeToDecimal(
								'28/01/1991 00:00',
								'28/01/1991 ' + this.historico_comparacao.objeto.hora_navegacao
							) +
							')'
					} else {
						decimal = ' (0.0)'
					}
					return {
						mudou:
							this.form.hora_navegacao !=
							this.historico_comparacao.objeto.hora_navegacao,
						valor: this.historico_comparacao.objeto.hora_navegacao + decimal
					}
				}
			}
			if (tipo == 'combustivel') {
				if (
					this.form.combustivel != this.historico_comparacao.objeto.combustivel
				) {
					return {
						mudou:
							this.form.combustivel !=
							this.historico_comparacao.objeto.combustivel,
						valor: this.historico_comparacao.objeto.combustivel
					}
				}
			}
			if (tipo == 'unidade_combustivel') {
				if (
					this.form.unidade_combustivel !=
					this.historico_comparacao.objeto.unidade_combustivel
				) {
					return {
						mudou:
							this.form.unidade_combustivel !=
							this.historico_comparacao.objeto.unidade_combustivel,
						valor: this.historico_comparacao.objeto.unidade_combustivel
					}
				}
			}
			if (tipo == 'partidas') {
				if (this.form.partidas != this.historico_comparacao.objeto.partidas) {
					return {
						mudou:
							this.form.partidas != this.historico_comparacao.objeto.partidas,
						valor: this.historico_comparacao.objeto.partidas
					}
				}
			}
			if (tipo == 'pousos') {
				if (this.form.pousos != this.historico_comparacao.objeto.pousos) {
					return {
						mudou: this.form.pousos != this.historico_comparacao.objeto.pousos,
						valor: this.historico_comparacao.objeto.pousos
					}
				}
			}
			if (tipo == 'guincho') {
				if (this.form.guincho != this.historico_comparacao.objeto.guincho) {
					return {
						mudou:
							this.form.guincho != this.historico_comparacao.objeto.guincho,
						valor: this.historico_comparacao.objeto.guincho
					}
				}
			}
			if (tipo == 'gancho') {
				if (this.form.gancho != this.historico_comparacao.objeto.gancho) {
					return {
						mudou: this.form.gancho != this.historico_comparacao.objeto.gancho,
						valor: this.historico_comparacao.objeto.gancho
					}
				}
			}
			if (tipo == 'pax') {
				if (
					this.form.passageiro.length !=
					this.historico_comparacao.objeto.passageiro.length
				) {
					return {
						mudou:
							this.form.passageiro.length !=
							this.historico_comparacao.objeto.passageiro.length,
						valor: this.historico_comparacao.objeto.passageiro.length
					}
				}
			}
			if (tipo == 'pob') {
				let pob_form = this.form.passageiro.length + this.form.tripulacao.length
				let pob_hist =
					this.historico_comparacao.objeto.passageiro.length +
					this.historico_comparacao.objeto.tripulacao.length
				if (pob_form != pob_hist) {
					return {
						mudou: pob_form != pob_hist,
						valor: pob_hist
					}
				}
			}
			if (tipo == 'flir') {
				if (this.form.flir != this.historico_comparacao.objeto.flir) {
					let historico
					if (this.historico_comparacao.objeto.flir == 0) {
						historico = 'NÃO'
					} else if (this.historico_comparacao.objeto.flir == 1) {
						historico = 'SIM'
					}
					return {
						mudou: this.form.flir != this.historico_comparacao.objeto.flir,
						valor: historico
					}
				}
			}
			if (tipo == 'ovn') {
				if (this.form.ovn != this.historico_comparacao.objeto.ovn) {
					let historico
					if (this.historico_comparacao.objeto.ovn == 0) {
						historico = 'NÃO'
					} else if (this.historico_comparacao.objeto.ovn == 1) {
						historico = 'SIM'
					}
					return {
						mudou: this.form.ovn != this.historico_comparacao.objeto.ovn,
						valor: historico
					}
				}
			}
			return false
		},

		carregaHistorico(idDiario) {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			this._httpGet(
				'mg-siga/Relatorio_voo_trecho/get_historico/' + idDiario,
				(retorno) => {
					bus.$emit('load-out')
					if (retorno._request && retorno._status) {
						for (var i = 0; i < retorno.lista.length - 1; i++) {
							retorno.lista[i].acionamento = this._SQLDateToDateTime(
								retorno.lista[i].acionamento,
								$sessao.getDateFormat() + ' HH:MM'
							)
							retorno.lista[i].decolagem = this._SQLDateToDateTime(
								retorno.lista[i].decolagem,
								$sessao.getDateFormat() + ' HH:MM'
							)
							retorno.lista[i].corte = this._SQLDateToDateTime(
								retorno.lista[i].corte,
								$sessao.getDateFormat() + ' HH:MM'
							)
							retorno.lista[i].exibir = false
							retorno.lista[i].carregando = false
							this.historico.push(retorno.lista[i])
						}
						this.loadHistorico = false
					}
				}
			)
		},

		carregaSnOVN() {
			for (let i = 0; i < this.form.tripulacao.length; i++) {
				if (this.form.tripulacao[i].id_ovn) {
					for (let index = 0; index < this.ovns.length; index++) {
						if (this.form.tripulacao[i].id_ovn === this.ovns[index].id) {
							this.form.tripulacao[i].sn_ovn = this.ovns[index].sn
							break
						}
					}
				} else {
					this.form.tripulacao[i].sn_ovn = null
				}
			}
		},

		carregaOrdem(ordem) {
			this.ordem = ordem
		},

		carregaDespacho(despacho) {
			this.despacho = despacho
		},

		geraMapa(posicoes) {
			this.configMapa.lat = Number($cliente.getVersao('lat_inicio'))
			this.configMapa.long = Number($cliente.getVersao('long_inicio'))
			this.configMapa.zoom = 11

			// exluir e inicia um novo mapa
			this.initMap(
				this.configMapa.lat,
				this.configMapa.long,
				this.configMapa.zoom
			)

			var bounds = new google.maps.LatLngBounds()
			this.removPolylines(null)
			this.trilhas = []
			this.removeMarkers(null)
			this.markers = []

			var polyTrilha = []

			var latInit = parseFloat(posicoes[0].lat)
			var lgnInit = parseFloat(posicoes[0].lng)

			var lenghPlots = posicoes.length

			for (var i in posicoes) {
				polyTrilha.push({
					lat: Number(posicoes[i].lat),
					lng: Number(posicoes[i].lng)
				})
				this.geraMarkers(posicoes[i], Number(i), lenghPlots)
				bounds.extend(polyTrilha[i])
			}

			// polyline com o movimento
			var polylineLinhaConfig = new google.maps.Polyline({
				strokeColor: $cliente.getVersao('cor_polilyne'),
				path: polyTrilha,
				strokeOpacity: 1,
				icons: [
					{
						scale: 0.8,
						icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
						offset: '1',
						repeat: '90px'
					}
				]
			})

			polylineLinhaConfig.setMap(this.map)

			// add as poly na lista
			this.trilhas.push(polylineLinhaConfig)
			this.map.fitBounds(bounds)
		},

		getTipoVelocidade(versao, item) {
			if (versao == 'S') {
				return item.velocidade_km
			}

			return item.velocidade + ' kt'
		},

		// Gera o rastro da aeronave
		geraMarkers(item, i, lenghPlots) {
			var strginInfo = ''
			var marker = ''
			var img = ''

			if (i == 0) {
				var img = new google.maps.MarkerImage(
					this._getPin('verde'),
					null, //new google.maps.Size(65, 65, "px", "px"),
					null, // new google.maps.Point(0, 0),
					null, //new google.maps.Point(20, 20),
					null
				)

				strginInfo = "<table style='width:100%'>"
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>"
				strginInfo +=
					"<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>"
				strginInfo +=
					'<strong>' +
					this._traducao('global', 'inicio').toUpperCase() +
					'</strong>'
				strginInfo += '</td></tr>'
			} else if (i == lenghPlots - 1) {
				var img = new google.maps.MarkerImage(
					this._getPin('azul'),
					null, //new google.maps.Size(65, 65, "px", "px"),
					null, // new google.maps.Point(0, 0),
					null, //new google.maps.Point(20, 20),
					null //new google.maps.Size(18, 30)
				)

				strginInfo = "<table style='width:100%'>"
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>"
				strginInfo +=
					"<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>"
				strginInfo +=
					'<strong>' +
					this._traducao('global', 'fim').toUpperCase() +
					'</strong>'
				strginInfo += '</td></tr>'
			} else {
				var img = new google.maps.MarkerImage(
					this._getLinkImage(
						item.tipo,
						'N',
						item.direcao,
						item.cor,
						true,
						item.icone
					),
					null, //new google.maps.Size(65, 65, "px", "px"),
					null, // new google.maps.Point(0, 0),
					new google.maps.Point(20, 20),
					new google.maps.Size(40, 40)
				)

				strginInfo = "<table style='width:100%'>"
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>"
				strginInfo +=
					"<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>"
				strginInfo +=
					'<strong>' +
					this._traducao('global', 'posicao').toUpperCase() +
					' ' +
					(i + 1) +
					' ' +
					'</strong>'
				strginInfo += '</td></tr>'
			}

			// informacoes de posicoes
			strginInfo += '<tr>'
			strginInfo += "<td style='padding:10px'>"
			strginInfo += '<table>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{HORA}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.hora +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{VELOCIDADE}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				this.getTipoVelocidade(this._versaoSistema, item) +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{ALTITUDE}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				this._metersToFt(item.altitude) +
				`/${item.altitude}m`
			;('</td></tr>')
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{DIRECAO}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.direcao +
				'º' +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{LAT}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				this._convertDMS(item.lat, item.lng).lat +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{LNG}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				this._convertDMS(item.lat, item.lng).lng +
				'</td></tr>'
			strginInfo += '</table>'
			strginInfo += '</td>'

			strginInfo += '</tr>'
			strginInfo += '</table>'

			strginInfo = strginInfo.replace(
				'{{AERONAVE}}',
				this._traducao('global', 'aeronave').toUpperCase()
			)
			strginInfo = strginInfo.replace(
				'{{DATA}}',
				this._traducao('global', 'data').toUpperCase()
			)
			strginInfo = strginInfo.replace(
				'{{HORA}}',
				this._traducao('global', 'hora').toUpperCase()
			)
			strginInfo = strginInfo.replace(
				'{{VELOCIDADE}}',
				this._traducao('global', 'velocidade').toUpperCase()
			)
			strginInfo = strginInfo.replace(
				'{{ALTITUDE}}',
				this._traducao('global', 'altitude').toUpperCase()
			)
			strginInfo = strginInfo.replace(
				'{{DIRECAO}}',
				this._traducao('global', 'direcao').toUpperCase()
			)
			strginInfo = strginInfo.replace(
				'{{LAT}}',
				this._traducao('global', 'lat').toUpperCase()
			)
			strginInfo = strginInfo.replace(
				'{{LNG}}',
				this._traducao('global', 'lng').toUpperCase()
			)

			var myLatLng = {lat: Number(item.lat), lng: Number(item.lng)}

			marker = new google.maps.Marker({
				position: myLatLng,
				map: this.map,
				options: {
					icon: img,
					animation:
						i == 0 || i == lenghPlots - 1 ? google.maps.Animation.DROP : null
				}
			})

			// gera o info view na aeronave
			marker.info = new google.maps.InfoWindow({
				content: strginInfo
			})

			// add o evento qnado passa o mouse
			google.maps.event.addListener(
				marker,
				'mouseover',
				((marker, i) => {
					return () => {
						marker.info.open(this.map, marker)
					}
				})(marker, i)
			)

			// add o vento quando sai o maou
			google.maps.event.addListener(
				marker,
				'mouseout',
				((marker, i) => {
					return () => {
						marker.info.close(this.map, marker)
					}
				})(marker, i)
			)

			this.markers.push(marker)
		},

		// remove se existir os markers do mapa
		removeMarkers(map) {
			for (var j = 0; j < this.markers.length; j++) {
				this.markers[j].setMap(null)
			}
		},

		// remove as polylines os markers do mapa
		removPolylines(map) {
			for (var j = 0; j < this.trilhas.length; j++) {
				this.trilhas[j].setMap(null)
			}
		},

		// inicia o mapa
		initMap(lat, lng, zoom) {
			this.map = null

			let latLong = new google.maps.LatLng(lat, lng)

			let mapOp = {
				//center: latLong,
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				mapTypeControl: false,
				fullscreenControl: false,
				mapTypeControlOptions: {
					position: google.maps.ControlPosition.TOP_RIGHT
					//style : google.maps.MapTypeControlStyle.DROPDOWN_MENU
				},
				zoomControl: false,
				zoomControlOptions: {
					position: google.maps.ControlPosition.TOP_RIGHT
				},
				navigationControl: false,
				scrollwheel: true,
				streetViewControl: false
			}

			this.map = new google.maps.Map(this.$refs.map, mapOp)

			this._adicionaBotoes(this.map)
		},

		carregaDados(obj) {
			this.exibir = true

			this.form = obj.data
			this.aeronave = obj.aero
			this.ovns = obj.ovns
			this.pilotos = obj.pilotos
			this.posicoes = []
			this.vitimas = []
			this.passageiros = []
			this.trecho = obj.trecho
			this.form.lng_inicio = obj.lng_inicio
			this.form.lng_fim = obj.lng_fim
			this.lat_inicio = obj.lat_inicio
			this.lat_fim = obj.lat_fim

			/* if (this.mostraVor) {
				// ESTADOS
				this._providerEstado((lista) => {
					if (this.form.verificacao_vor[0].id_estado != '') {
						// CIDADES
						this._httpGet(
							'/Cidade/get_cidade_by_id_estado/' +
								this.form.verificacao_vor[0].id_estado,
							({lista}) => {
								this.form.verificacao_vor[0].id_cidade = lista
									.find(
										(cidade) =>
											cidade.id == this.form.verificacao_vor[0].id_cidade
									)
									.descricao.toUpperCase()
							}
						)
						this.form.verificacao_vor[0].id_estado = lista.find(
							(estado) => estado.id == this.form.verificacao_vor[0].id_estado
						).nome
					}
				})
			} */

			this.form.discrepancia.map((o) => {
				let ata = `${o.ata_numero} - ${o.ata_capitulo} - ${o.ata_descricao}`

				o._ata_completa = _.isNil(o.id_ata) ? '' : ata.toUpperCase()

				return o
			})

			if (this.form.hora_navegacao != '00:00:00') {
				this.form.navegacao = this._timeToDecimal(
					'28/01/1991 00:00',
					'28/01/1991 ' + this.form.hora_navegacao
				)
			}

			if (this.form.vfr_diurno != '00:00:00') {
				this.form.vfr_diurno = this._timeToDecimal(
					'28/01/1991 00:00',
					'28/01/1991 ' + this.form.hora_vfr_diurno
				)
			}

			if (this.form.hora_vfr_noturno != '00:00:00') {
				this.form.vfr_noturno = this._timeToDecimal(
					'28/01/1991 00:00',
					'28/01/1991 ' + this.form.hora_vfr_noturno
				)
			}

			if (this.form.hora_ifr != '00:00:00') {
				this.form.ifr = this._timeToDecimal(
					'28/01/1991 00:00',
					'28/01/1991 ' + this.form.hora_ifr
				)
			}

			if (this.form.hora_vfr != '00:00:00') {
				this.form.vfr = this._timeToDecimal(
					'28/01/1991 00:00',
					'28/01/1991 ' + this.form.hora_vfr
				)
			}

			// tipo de exibição do diário: C: completo, I: incisos XIII a XVII do art. 4º da resolução 457
			if (!_.isNil(obj.tipo)) {
				this.tipo = obj.tipo
			} else {
				this.tipo = 'C'
			}

			if (this.form.id_ordem_missao == null) {
				this.ordem = ''
			}

			if (this.form.id_despacho_emergencial == null) {
				this.despacho = ''
			}

			for (var i in this.form.passageiro) {
				if (this.form.passageiro[i].tipo == 'V') {
					this.vitimas.push(this.form.passageiro[i])
				} else {
					this.passageiros.push(this.form.passageiro[i])
				}
			}
			if (this.voo == true) {
				if (obj.trecho.rastreado == true) {
					this._httpGet(
						'mg-siga/Relatorio_voo_trecho/get_rastreamento/' + this.form.id,
						(response) => {
							// bus.$emit('load-out')
							if (response._request) {
								if (response.lista.length > 0) {
									this.posicoes = response.lista
									this.map = null
									this.$nextTick(() => {
										this.geraMapa(response.lista)
									})
								}
							}
						}
					)
				} else {
					this.map = null
				}
			} else {
				this.map = null
			}
			if (this.exibeHistoricoVisualizar) {
				this.carregaHistorico(this.form.id)
			}

			this.carregaSnOVN()
		},

		verificaOvn(lista) {
			return lista.some((obj) => obj.id_ovn !== null)
		},

		_exibeRedsSamu() {
			this._getParametro(22).then((valor) => (this.exibeRedsSamu = valor))
		},

		numeroOcorrenciasSamu() {
			this._getParametro(18).then(
				(valor) => (this.numeroOcorrenciaSamu = valor)
			)
		},

		numeroOcorrencias193() {
			this._getParametro(19).then((valor) => (this.numeroOcorrencia193 = valor))
		},

		clickPrintPassageiro(item, tipo, id_diario = null) {
			let url = `mg-siga/Ordem_missao/${tipo}/${item.id_ordem}/${
				item.id_despacho
			}/${id_diario}/${$sessao.getToken()}`
			url = this.getURL_WS(url)
			let a = document.createElement('a')
			a.href = url
			a.target = '_blank'
			document.body.appendChild(a)
			a.click()

			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})
			window.bus.$emit('load-out')
		},

		calculaHorimetroProximaIntervencao() {
			let sub = Number(
				Number(this.form.horimetro_proxima) -
					Number(this.form.horimetro_final_manutencao)
			).toFixed(1)
			return sub
		}
	}
}
</script>
<style>
.ha-diferenca {
	color: red;
	font-size: 11px;
}
</style>